import { PayloadAction, createSlice } from '@reduxjs/toolkit';

export interface KycTabValues {
  basicKycTab: 'mobileNumber' | 'personalInfo' | 'bankInfo';
  advanceKycTab: 'identity' | 'selfie';
  modifyDocFlag: boolean;
  reviewDocFlag: boolean;
  isKycPage: boolean;
  basicKycSuccessful: boolean;
  hasIdentityPic: boolean;
}

const initialState: KycTabValues = {
  basicKycTab: 'mobileNumber',
  advanceKycTab: 'identity',
  modifyDocFlag: false,
  reviewDocFlag: false,
  isKycPage: false,
  basicKycSuccessful: false,
  hasIdentityPic: true
};

const kyc = createSlice({
  name: 'kyc',
  initialState,
  reducers: {
    changeBasicInfoKycSuccessful: (state, action) => {
      state.basicKycSuccessful = action.payload;
    },
    changeIsKycPage: (state, action) => {
      state.isKycPage = action.payload;
    },
    basicTabChange: (state, action) => {
      state.basicKycTab = action.payload;
    },
    advanceTabChange: (state, action) => {
      state.advanceKycTab = action.payload;
    },
    modifyDocFlagChange: (state, action) => {
      state.modifyDocFlag = action.payload;
    },
    reviewDocFlagChange: (state, action) => {
      state.reviewDocFlag = action.payload;
    },
    identityPicFlagChange: (state, action) => {
      state.hasIdentityPic = action.payload;
    }
  }
});

// Action creators are generated for each case reducer function
export const {
  basicTabChange,
  advanceTabChange,
  reviewDocFlagChange,
  modifyDocFlagChange,
  changeIsKycPage,
  changeBasicInfoKycSuccessful,
  identityPicFlagChange
} = kyc.actions;

export default kyc.reducer;
